import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarShow: true,

  documentDetailModal: {
    show: false,
    title: '',
    path: '',
    fileType: '',
    isMultiple: false,
    canUpload: true,
    offerId: '',
    showVersion: true,
  },
  fileHistoryModal: {
    show: false,
    title: '',
    files: [],
    canEdit: false,
    fileType: '',
  },
  approvalRemarkModal: {
    show: false,
    modalType: '',
    canUploadCommercialProposal: false,
    currentOffer: {},
  },

  batchPostModal: {
    show: false,
    offerId: '',
    costBudgetDetailIndex: 0,
  },
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarShow = !state.sidebarShow
    },

    setDocumentDetailModal(state, action) {
      state.documentDetailModal = {
        ...state.documentDetailModal,
        ...action.payload,
      }
    },
    setFileHistoryModal(state, action) {
      state.fileHistoryModal = {
        ...state.fileHistoryModal,
        ...action.payload,
      }
    },

    setApprovalRemarkModal(state, action) {
      state.approvalRemarkModal = {
        ...state.approvalRemarkModal,
        ...action.payload,
      }
    },

    setBatchPostModal(state, action) {
      state.batchPostModal = {
        ...state.batchPostModal,
        ...action.payload,
      }
    },
  },
})

export const { toggleSidebar, setApprovalRemarkModal, setDocumentDetailModal, setFileHistoryModal, setBatchPostModal } =
  uiSlice.actions
export default uiSlice.reducer

export const uiSelector = (state) => state.ui
